import {
    createAction,
    createAsyncThunk,
    createSlice } from "@reduxjs/toolkit";
import SnpError from "../exceptions/SnpError";
import { isEmpty,
    lowerCase } from "lodash";
import {
  BillStatus,
  getAuthSession,
  FETCH_BILL,
  OfferType,
  printDebugLog,
  SUCCESS
} from "../constants/constant";
import { snpAxios } from "../components/global/api";
import {
  INITIAL_BILL_CUSTOMER_DETAILS,
  INITIAL_BILL_DETAILS_STATE,
  INITIAL_BILL_HOTEL_DETAILS_STATE,
  INITIAL_BILL_PARTIAL_PAY_STATE,
  INITIAL_BILL_PAYMENT_DETAILS_STATE,
  INITIAL_RIDER_DETAILS_STATE,
} from "../constants/restoConstant";

const INITIAL_LOADING_AND_ERROR_STATE = {
  loading: false,
  error: {
    status: null,
    message: null,
  },
};
const billDetails = createSlice({
  name: "bill",
  initialState: {
    billDetails: INITIAL_BILL_DETAILS_STATE,
    billPaymentDetails: INITIAL_BILL_PAYMENT_DETAILS_STATE,
    billHotelDetails: INITIAL_BILL_HOTEL_DETAILS_STATE,
    billRiderDetails: INITIAL_RIDER_DETAILS_STATE,
    billCustomerDetails: INITIAL_BILL_CUSTOMER_DETAILS,
    billItems: [],
    billCachedProductDetails: [],
    billPartialPaymentDetails: INITIAL_BILL_PARTIAL_PAY_STATE,
    billDeletedItems: [],
    // API-specific state
    billDetailsFetch: INITIAL_LOADING_AND_ERROR_STATE,
    billItemsFetch:  INITIAL_LOADING_AND_ERROR_STATE,
    billPaymentFetch: INITIAL_LOADING_AND_ERROR_STATE,
    billPartialPaymentFetch: INITIAL_LOADING_AND_ERROR_STATE,
    error: {
      status: null,
      message: null,
    },
  },
  reducers: {
    setBillDetails: (state, action) => {
      state.billDetails = action.payload;
    },

    addItemToBill: (state, action) => {
      console.log("addBillItem: action.payload", action.payload);
      state.billItems.push(action.payload);
    },

    removeItemFromBill: (state, action) => {
      state.billItems = state.billItems.filter(
        (item) => item.prdId !== action.payload.prdId
      );
    },
    updateBillItem: (state, action) => {
      console.log("updating billItem: ", action.payload);

      const updatedItem = action.payload;
      const index = state.billItems.findIndex(
        (item) => item.prdId === updatedItem.prdId
      );

      if (index !== -1) {
        state.billItems[index] = updatedItem;
      }
    },

    updateBillDetails: (state, action) => {
      const updatedBill = action.payload;
      console.log("prevState bdts:", state.billDetails);
      console.log("prevState bdts bt:", state.billDetails.billType);
      console.log("new bdts bt:", action.payload.billType);

      state.billDetails = { ...state.billDetails, ...updatedBill };
    },

    updateBillPaymentDetails: (state, action) => {
      const updatedDetails = action.payload;
      console.log("updateBillPaymentDetails bdts:", state.billPaymentDetails);
      console.log("updateBillPaymentDetails bdts:", updatedDetails);
      state.billPaymentDetails = {
        ...state.billPaymentDetails,
        ...updatedDetails,
      };
    },

    updatebillHotelDetails: (state, action) => {
      const updatedDetails = action.payload;
      state.billHotelDetails = { ...state.billHotelDetails, ...updatedDetails };
    },

    updateBillRiderDetails: (state, action) => {
      const updatedDetails = action.payload;

      state.billRiderDetails = { ...state.billRiderDetails, ...updatedDetails };
    },

    updateBillCustomerDetails: (state, action) => {
      const updatedDetails = action.payload;
      state.billCustomerDetails = {
        ...state.billCustomerDetails,
        ...updatedDetails,
      };
    },

    updateBillPartialPaymentDetails: (state, action) => {
      const updatedDetails = action.payload;
      state.billPartialPaymentDetails = {
        ...state.billPartialPaymentDetails,
        ...updatedDetails,
      };
    },

    addDeletedBillItem: (state, action) => {
      console.log("adding deleted billItem: ", action.payload);
      state.billDeletedItems.push(action.payload);
    },
    addCachedBillProductDetails: (state, action) => {
      console.log("adding cached product details: ", action.payload);

      state.billCachedProductDetails.push(action.payload);
    },
    clearBill: (state) => {
      state.billDetails = INITIAL_BILL_DETAILS_STATE;
      state.billPaymentDetails = INITIAL_BILL_PAYMENT_DETAILS_STATE;
      state.billHotelDetails = INITIAL_BILL_HOTEL_DETAILS_STATE;
      state.billRiderDetails = INITIAL_RIDER_DETAILS_STATE;
      state.billCustomerDetails = INITIAL_BILL_CUSTOMER_DETAILS;
      state.billPartialPaymentDetails = INITIAL_BILL_PARTIAL_PAY_STATE;
      state.billItems = [];
      state.billDeletedItems = [];
      state.billCachedProductDetails = [];
      state.error = {
        status: null,
        message: null,
      };
      state.billDetailsFetch = resetFetchState(state.billDetailsFetch);
      state.billItemsFetch = resetFetchState(state.billItemsFetch);
      state.billPaymentFetch = resetFetchState(state.billPaymentFetch);
      state.billPartialPaymentFetch = resetFetchState(
        state.billPartialPaymentFetch
      );
    },
  },
  extraReducers: (builder) => {
    builder
      // .addCase(fetchBillDetails.pending, (state) => {
      //   console.log("action.payload fetch bill pending: ");
      //   state.loading = true;
      //   state.error = {
      //     status: null,
      //     message: null,
      //   };
      // })
      // .addCase(fetchBillDetails.fulfilled, (state, action) => {
      //   console.log("action.payload fetch bill success: ", action.payload);
      //   state.billItems = action.payload;
      //   state.billItems = populateBillItem(action.payload.value_2);
      //   state.billDetails = {
      //     ...state.billDetails,
      //     ...populateBillDetails(action.payload),
      //   };
      //   state.billPaymentDetails = {
      //     ...state.billPaymentDetails,
      //     ...populatePaymentsDetails(action.payload),
      //   };
      //   state.billCustomerDetails = {
      //     ...state.billCustomerDetails,
      //     ...populateCustomerDetails(action.payload),
      //   };
      //   state.billRiderDetails = {
      //     ...state.billRiderDetails,
      //     ...populateRiderDetails(action.payload),
      //   };
      //   state.billHotelDetails = {
      //     ...state.billHotelDetails,
      //     ...populateRoomDetails(action.payload),
      //   };
      //   state.loading = false;
      //   state.error = {
      //     status: null,
      //     message: null,
      //   };
      // })
      // .addCase(fetchBillDetails.rejected, (state, action) => {
      //   //  ;
      //   console.log("action.payload fetch bill rejected: ", action.payload);
      //   state.loading = false;
      //   state.error = {
      //     status: action.payload.status,
      //     message: action.payload.message,
      //   };

      //   state.billCachedProductDetails = [];
      //   const { billType, tableId, tableNo, tableName } = state.billDetails;
      //   state.billDetails = {
      //     ...INITIAL_BILL_DETAILS_STATE,
      //     billNo: "",
      //     billType,
      //     tableId,
      //     tableNo,
      //     tableName,
      //     offerDenom: OfferType.No_Offer,
      //   };
      //   state.billCustomerDetails = INITIAL_BILL_CUSTOMER_DETAILS;
      //   state.billItems = [];
      //   state.billPaymentDetails = INITIAL_BILL_PAYMENT_DETAILS_STATE;
      //   state.billRiderDetails = INITIAL_RIDER_DETAILS_STATE;
      //   state.billHotelDetails = INITIAL_BILL_HOTEL_DETAILS_STATE;
      // })

      // Fetch Bill Details
      .addCase(fetchBillDetails1.pending, (state) =>
        handlePending(state, "billDetailsFetch")
      )
      .addCase(fetchBillDetails1.fulfilled, handleBillDetailsFulfilled)
      .addCase(fetchBillDetails1.rejected, (state, action) =>
        handleRejected(state, action, "billDetailsFetch")
      )

      // Fetch Bill Items
      .addCase(fetchBillItems.pending, (state) =>
        handlePending(state, "billItemsFetch")
      )
      .addCase(fetchBillItems.fulfilled, handleBillItemsFulfilled)
      .addCase(fetchBillItems.rejected, (state, action) =>
        handleRejected(state, action, "billItemsFetch")
      )

      // Fetch Bill Payment
      .addCase(fetchBillPaymentDetails.pending, (state) =>
        handlePending(state, "billPaymentFetch")
      )
      .addCase(fetchBillPaymentDetails.fulfilled, handleBillPaymentFulfilled)
      .addCase(fetchBillPaymentDetails.rejected, (state, action) =>
        handleRejected(state, action, "billPaymentFetch")
      )

      // Fetch Bill Partial Payment
      .addCase(fetchBillPartialPayDetails.pending, (state) =>
        handlePending(state, "billPaymentFetch")
      )
      .addCase(
        fetchBillPartialPayDetails.fulfilled,
        handleBillPartialPaymentFulfilled
      )
      .addCase(fetchBillPartialPayDetails.rejected, (state, action) =>
        handleRejected(state, action, "billPartialPaymentFetch")
      )
      //Case to update complete bill data
      .addCase(updateAllBillData, (state, action) => {
        const {
          billDetails,
          billPaymentDetails,
          billPartialPaymentDetails,
          billCustomerDetails,
          billHotelDetails,
          billRiderDetails,
        } = action.payload;
        console.log(
          "updating all bill data: ",
          billDetails,
          billPaymentDetails
        );

        if (billDetails) {
          state.billDetails = { ...state.billDetails, ...billDetails };
        }
        if (billPaymentDetails) {
          state.billPaymentDetails = {
            ...state.billPaymentDetails,
            ...billPaymentDetails,
          };
        }
        if (billPartialPaymentDetails) {
          state.billPartialPaymentDetails = {
            ...state.billPartialPaymentDetails,
            ...billPartialPaymentDetails,
          };
        }

        if (billCustomerDetails) {
          state.billCustomerDetails = {
            ...state.billCustomerDetails,
            ...billCustomerDetails,
          };
        }

        if (billHotelDetails) {
          state.billHotelDetails = {
            ...state.billHotelDetails,
            ...billHotelDetails,
          };
        }
      });
  },
});

export const updateAllBillData = createAction("bill/updateAllBillData");

const paeseFetchedBillDetails = () => {};

// const parseBillDetails = (state, action) => {
//   state.billItems = action.payload.value_2;
//   state.billDetails = {
//     ...state.billDetails,
//     ...populateBillDetails(action.payload),
//   };
//   state.
// };

const populateBillItem = (items) => {
  console.log("billItems: ", items);
  // ;
  return items && Array.isArray(items)
    ? items.map((item) => {
        return {
          ...item,
          prdId: item.prdId,
          finalPrice: item.finalprice,
        };
      })
    : [];
};
const isBillPaid = (rawData) => {
  // ;
  return (
    rawData.billStatus === BillStatus.CANCEL_BILL ||
    rawData.billStatus === BillStatus.PAID ||
    rawData.billStatus === BillStatus.PARTIALLYPAID ||
    rawData.billStatus === BillStatus.HOMEDELIVERYINITIATED ||
    rawData.billStatus === BillStatus.HOMEDELIVERYCASHPAY ||
    rawData.billStatus === BillStatus.HOMEDELIVERYPAY
  );
};
const populateBillDetails = (rawData) => {
  console.log("rawData: ", rawData);

  return {
    // subTotal: rawData.totalPrice,
    // cgst: rawData.cgst,
    // cgstAmt: rawData.cgstAmt,
    // sgstAmt: rawData.sgstAmt,
    // sgst: rawData.sgst,
    // isGstAllowed: rawData.isGstAllowed,
    // roundOff: rawData.roundOff,
    //total: rawData.finalPrice,
    pointRedeem: rawData.pointRedeem,
    isPointAdded: parseFloat(rawData.pointRedeem) > 0.0,
    lapsedTime: rawData.lapsedTime,
    billType: rawData.billType,
    token: rawData.tokenNo,
    kotNo: rawData.kot,
    billNo: rawData.billNo,
    tableId: rawData && rawData.billUtils ? rawData.billUtils.tableId : "",
    tableNo: rawData && rawData.billUtils ? rawData.billUtils.tableNo : "",
    tableName: rawData && rawData.billUtils ? rawData.billUtils.tableName : "",
    billType:
      rawData && rawData.billUtils ? parseInt(rawData.billUtils.billType) : "",
    billStatus: rawData.billStatus,
    billedFrom: rawData.billedFrom,
    createdAt: rawData.createdAt,
    tripUpdateReq:
      rawData && rawData.tripMap ? rawData.tripMap.tripUpdateReq : "",
    tripStatus: rawData && rawData.tripMap ? rawData.tripMap.tripStatus : "",
    pTripStatus: rawData.pTripStatus,
    assignedBy: rawData.assignedBy,
    assignedByName: rawData.assignedByName,
    transactionId:
      rawData && rawData.externalMap ? rawData.externalMap.transactionId : "",
    settleDown: rawData.settleDown,
    generateOtp: rawData.generateOtp,
    onlineBillOtherName: rawData.onlineBillOtherName,
    delvName: rawData.delvName,
    isPaid: isBillPaid(rawData),
    payAtCounterOpt:
      rawData && rawData.externalMap ? rawData.externalMap.payAtCounterOpt : "",
    payLaterSignal:
      rawData && rawData.externalMap ? rawData.externalMap.payLaterSignal : "",
    homeDelvId:
      rawData && rawData.externalMap ? rawData.externalMap.homeDelvId : "",
    homeDelvOtp:
      rawData && rawData.externalMap ? rawData.externalMap.homeDelvOtp : "",
    // offerDenom: rawData.takenDenom,
    // offerAmt: rawData.takenOffrAmt,
  };
};

const populatePaymentsDetails = (rawData) => {
  // ;
  return {
    cashTender: rawData.cashTender,
    cashReturn: rawData.cashReturn,
    onlinePay: rawData.onlinePay,
    cashPay: rawData.cashPay,
    cashPayThrough: rawData.cashPayThrough,
    onlinePayMedium: rawData.onlinePayMedium,
    onlinePayThrough: rawData.onlinePayThrough,
    onlineBillOtherName: rawData.onlineBillOtherName,
    isOnlinePayEnabled: lowerCase(rawData.onlinePayThrough) === "online",
    isCashPayEnabled: lowerCase(rawData.cashPayThrough) === "cash",
    delvName: rawData.delvName,
    payMedium: rawData.payMedium,
    deliveryCharge: rawData.delvCharge,
    sgst: rawData.sgst,
    cgst: rawData.cgst,
    totalPrice: rawData.totalPrice,
    finalPrice: rawData.finalPrice,
    sgstAmt: rawData.sgstAmt,
    cgstAmt: rawData.cgstAmt,
    roundOff: rawData.roundOff,
    offerType: rawData.takenDenom,
    offerValue: rawData.takenOffrAmt,
    isGstAllowed: rawData.isGstAllowed,
    subTotal: rawData.totalPrice,
    coupon: rawData.coupon,
  };
};

const populatePartialBillPaymentDetails = (rawData) => {
  return {
    duesAmt: rawData.duesAmt,
    partiallyPaid: rawData.takenPartialPay,
    lpatialAmt: rawData.lpatialAmt,
  };
};
const populateCustomerDetails = (rawData) => {
  // ;
  const custmerDetails = rawData.customerData;
  return {
    custMob: custmerDetails.custMob,
    custName: custmerDetails.custName,
    custEmail: custmerDetails.custEmail,
    address: custmerDetails.address,
    custId: custmerDetails.custId,
    custGstDetails: custmerDetails.custGstDetails,
    custCompanyName: custmerDetails.custCompanyName,
  };
};
const populateRiderDetails = (rawData) => {
  // ;
  const riderDetails = rawData.tripMap;
  return {
    riderId: riderDetails.riderId,
    riderName: riderDetails.riderIdName,
  };
};

const populateRoomDetails = (rawData) => {
  const hotelDetails = rawData.externalMap;
  return {
    roomNo: hotelDetails ? hotelDetails.hotelBillNo : "",
    hotelBillId: hotelDetails ? hotelDetails.hotelBillId : "",
    hotelBillNo: hotelDetails ? hotelDetails.hotelBillNo : "",
    saved: hotelDetails ? !isEmpty(hotelDetails.hotelBillNo) : false,
    roomBooked: hotelDetails ? !isEmpty(hotelDetails.hotelBillNo) : false,
  };
};
// export const fetchBillDetails = createAsyncThunk(
//   "billDetails/fetchBillDetails",
//   async (mBillNo, thunkAPI) => {
//     console.log("bill No: ", mBillNo);

//     if (!isEmpty(mBillNo)) {
//       const state = thunkAPI.getState();
//       const storeApiUrl = state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL;
//       const shopHash = state.setActiveShopHashReducer.activeShopHash;
//       let fetchBillUrl = storeApiUrl?.BACKEND_BASE_URL + FETCH_BILL;
//       let data = {
//         jcJson: {
//           apiToken: getAuthSession?.apiToken,
//           billNo: mBillNo,
//           shopHash: shopHash?.id,
//         },
//       };
//       //printLog("fetchBill  => ", data);
//       snpAxios.post(fetchBillUrl, data).then((response) => {
//         //printDebugLog("fetchBill response  => ", response.data);
//         if (response.data.status === SUCCESS) {
//           return response.data.jcJson;
//         } else {
//           throw new SnpError(response.data.status, response.data.message);
//         }
//       });
//     } else {
//       //printLog("Empty Bill No");
//     }
//   }
// );

// export const fetchBillDetails = createAsyncThunk(
//   "billDetails/fetchBillDetails",
//   async (mBillNo, thunkAPI) => {
//     try {
//       console.log("bill No: ", mBillNo);

//       if (!isEmpty(mBillNo)) {
//         const state = thunkAPI.getState();
//         const storeApiUrl = state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL;
//         const shopHash = state.setActiveShopHashReducer.activeShopHash;
//         let fetchBillUrl = storeApiUrl?.BACKEND_BASE_URL + FETCH_BILL;
//         let data = {
//           jcJson: {
//             apiToken: getAuthSession?.apiToken,
//             billNo: mBillNo,
//             shopHash: shopHash?.id,
//           },
//         };

//         // Make the API call and return the data
//         const response = await snpAxios.post(fetchBillUrl, data);
//         console.log("res bill data: ", response.data);
//         if (response.data.status === SUCCESS) {
//           console.log("success,", response.data.jcJson);

//           return response.data.jcJson; // Ensure we return this data
//         } else {
//           console.log(" something failed: ");
//           return thunkAPI.rejectWithValue({
//             status: response.data.status,
//             message: response.data.message,
//           });
//         }
//       } else {
//         throw new SnpError(204, "Empty Bill No");
//       }
//     } catch (error) {
//       console.error("Fetch Bill Error: ", error);
//       return thunkAPI.rejectWithValue({
//         status: error.status || 500,
//         message: error.message || "Failed to fetch bill details",
//       });
//     }
//   }
// );

export const fetchBillDetails1 = createAsyncThunk(
  "billDetails/fetchBillDetails1",
  async (mBillNo, thunkAPI) => {
    try {
      console.log("bill No: ", mBillNo);

      if (!isEmpty(mBillNo)) {
        const state = thunkAPI.getState();
        const storeApiUrl = state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL;
        const shopHash = state.setActiveShopHashReducer.activeShopHash;
        const fetchBillUrl = `${storeApiUrl.BACKEND_BASE_URL}billing/get-bill-details?token=${getAuthSession().apiToken}&shopHash=${shopHash?.id}&billNo=${mBillNo}`;
        const response = await snpAxios.get(fetchBillUrl);
        printDebugLog("res bill data: ", response.data);
        if (response.data.status === SUCCESS) {
          return response.data.jcJson; // Ensure we return this data
        } else {
          console.log(
            "fetchBillDetails1",
            "something failed: mBillNo" + mBillNo
          );
          return thunkAPI.rejectWithValue({
            status: response.data.status,
            message: response.data.message,
          });
        }
      } else {
        throw new SnpError(204, "Empty Bill No");
      }
    } catch (error) {
      console.error("Fetch Bill Error: ", error);
      return thunkAPI.rejectWithValue({
        status: error.status || 500,
        message: error.message || "Failed to fetch bill details",
      });
    }
  }
);

export const fetchBillPaymentDetails = createAsyncThunk(
  "billDetails/fetchBillPaymentDetails",
  async (mBillNo, thunkAPI) => {
    try {
      console.log("bill No: ", mBillNo);

      if (!isEmpty(mBillNo)) {
        const state = thunkAPI.getState();
        const storeApiUrl = state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL;
        const shopHash = state.setActiveShopHashReducer.activeShopHash;

        // Make the API call and return the data
        const fetchBillPayUrl = `${storeApiUrl.BACKEND_BASE_URL}billing/get-bill-pay-details?token=${getAuthSession().apiToken}&shopHash=${shopHash?.id}&billNo=${mBillNo}`;
        const response = await snpAxios.get(fetchBillPayUrl);
        console.log("res bill data: ", response.data);
        if (response.data.status === SUCCESS) {
          console.log("success,", response.data.jcJson);
          return response.data.jcJson; // Ensure we return this data
        } else {
          console.log(" something failed: ");
          return thunkAPI.rejectWithValue({
            status: response.data.status,
            message: response.data.message,
          });
        }
      } else {
        throw new SnpError(204, "Empty Bill No");
      }
    } catch (error) {
      console.error("Fetch Bill Error: ", error);
      return thunkAPI.rejectWithValue({
        status: error.status || 500,
        message: error.message || "Failed to fetch bill details",
      });
    }
  }
);

export const fetchBillItems = createAsyncThunk(
  "billDetails/fetchBillItems",
  async (mBillNo, thunkAPI) => {
    try {
      console.log("bill No: ", mBillNo);

      if (!isEmpty(mBillNo)) {
        const state = thunkAPI.getState();
        const storeApiUrl = state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL;
        const shopHash = state.setActiveShopHashReducer.activeShopHash;
        const fetchBillItemUrl = `${storeApiUrl.BACKEND_BASE_URL}billing/get-bill-items?token=${getAuthSession().apiToken}&shopHash=${shopHash?.id}&billNo=${mBillNo}`;
        const response = await snpAxios.get(fetchBillItemUrl);
        console.log("res bill data: ", response.data);
        if (response.data.status === SUCCESS) {
          console.log("success,", response.data.jcJson);

          return response.data.jcJson; // Ensure we return this data
        } else {
          console.log(" something failed: ");
          return thunkAPI.rejectWithValue({
            status: response.data.status,
            message: response.data.message,
          });
        }
      } else {
        throw new SnpError(204, "Empty Bill No");
      }
    } catch (error) {
      console.error("Fetch Bill Error: ", error);
      return thunkAPI.rejectWithValue({
        status: error.status || 500,
        message: error.message || "Failed to fetch bill details",
      });
    }
  }
);

export const fetchBillPartialPayDetails = createAsyncThunk(
  "billDetails/fetchBillPartialPayDetails",
  async (mBillNo, thunkAPI) => {
    try {
      console.log("bill No: ", mBillNo);

      if (!isEmpty(mBillNo)) {
        const state = thunkAPI.getState();
        const storeApiUrl = state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL;
        const shopHash = state.setActiveShopHashReducer.activeShopHash;
        const fetchBillItemUrl = `${storeApiUrl.BACKEND_BASE_URL}billing/get-bill-partial-pay?token=${getAuthSession().apiToken}&shopHash=${shopHash?.id}&billNo=${mBillNo}`;
        const response = await snpAxios.get(fetchBillItemUrl);
        console.log("res bill data: ", response.data);
        if (response.data.status === SUCCESS) {
          console.log("success,", response.data.jcJson);

          return response.data.jcJson; // Ensure we return this data
        } else {
          console.log(" something failed: ");
          return thunkAPI.rejectWithValue({
            status: response.data.status,
            message: response.data.message,
          });
        }
      } else {
        throw new SnpError(204, "Empty Bill No");
      }
    } catch (error) {
      console.error("Fetch Bill Error: ", error);
      return thunkAPI.rejectWithValue({
        status: error.status || 500,
        message: error.message || "Failed to fetch bill details",
      });
    }
  }
);

// const fetchBill = async (mBill, mArray) => {
//   if (!isEmpty(mBill)) {
//     //setBillingData(INITIAL_LISTBILLINGDATA);
//     let fetchBillUrl = storeApiUrl.BACKEND_BASE_URL + FETCH_BILL;
//     let data = {
//       jcJson: {
//         apiToken: getAuthSession().apiToken,
//         billNo: mBill,
//         shopHash: storeActiveShopHash.id,
//       },
//     };
//     setSnpLoader(true);

//     //printLog("fetchBill  => ", data);
//     snpAxios
//       .post(fetchBillUrl, data)
//       .then((response) => {
//         printDebugLog("fetchBill response  => ", response.data);
//         if (response.data.status === SUCCESS) {
//           // if (mArray == null) {
//           //     setBillingData({
//           //         ...listbillingData, ...response.data.jcJson,
//           //     });
//           // } else {
//           //     setBillingData({
//           //         ...listbillingData, ...response.data.jcJson,
//           //         value_2:mArray,
//           //     });
//           // }
//           setSnpLoader(false);
//           setBillingData({
//             ...listbillingData,
//             ...response.data.jcJson,
//             value_2: response.data.jcJson.value_2,
//             pTripStatus: response.data.jcJson.tripStatus,
//             tripStatus: response.data.jcJson.tripStatus,
//           });
//           if (!isEmpty(response.data.jcJson.riderId))
//             // why we need to set again? change ho sakta hai rider kya?
//             setRiderDetails({
//               ...riderDetails,
//               id: response.data.jcJson.riderId,
//               name: response.data.jcJson.riderIdName,
//             });
//           if (response.data.jcJson.tripUpdateReq) {
//             //?
//             getRiderDetails(); // why?
//           }
//           setBillUtils({
//             ...billUtils,
//             tableId: response.data.jcJson.tableId,
//             tableNo: response.data.jcJson.tableNo,
//             billNo: response.data.jcJson.billNo,
//             tableName: response.data.jcJson.tableName,
//             billType: response.data.jcJson.billType,
//             billedFrom: response.data.jcJson.billedFrom,
//           });
//           if (!isEmpty(response.data.jcJson.hotelBillId)) {
//             setRoomDetails({
//               ...roomDetails,
//               roomNo: response.data.jcJson.hotelBillNo,
//               roomBooked: true,
//               hotelBillId: response.data.jcJson.hotelBillId,
//               saved: true,
//             });
//           }
//           setBillDetails({
//             ...billDetails,
//             subTotal: response.data.jcJson.totalPrice,
//             cgst: response.data.jcJson.cgst,
//             cgstAmt: response.data.jcJson.cgstAmt,
//             sgstAmt: response.data.jcJson.sgstAmt,
//             sgst: response.data.jcJson.sgst,
//             isGstAllowed: response.data.jcJson.isGstAllowed,
//             roundOff: response.data.jcJson.roundOff,
//             pointRedeem: response.data.jcJson.pointRedeem,
//             isPointAdded: parseFloat(response.data.jcJson.pointRedeem) > 0.0,
//             total: response.data.jcJson.finalPrice,
//             lapsedTime: response.data.jcJson.lapsedTime,
//             billType: response.data.jcJson.billType,
//             lpatialAmt: response.data.jcJson.lpatialAmt,
//             pendingAmt: response.data.jcJson.duesAmt,
//             token: response.data.jcJson.tokenNo,
//             offerDenom: response.data.jcJson.takenDenom,
//             offerAmt: response.data.jcJson.takenOffrAmt,
//           });
//           setPaymentDetails({
//             ...paymentDetails,
//             cashTender: response.data.jcJson.cashTender,
//             cashReturn: response.data.jcJson.cashReturn,
//             onlinePay: response.data.jcJson.onlinePay,
//             cashPay: response.data.jcJson.cashPay,
//             cashPayThrough: response.data.jcJson.cashPayThrough,
//             onlinePayMedium: response.data.jcJson.onlinePayMedium,
//             onlinePayThrough: response.data.jcJson.onlinePayThrough,
//             delvName: response.data.jcJson.delvName,
//             payMedium: response.data.jcJson.payMedium,
//           });

//           setDelvCharge(response.data.jcJson.delvCharge);
//           setDelvNameOth(response.data.jcJson.delvName);

//           setCustomerInputDialog({
//             ...customerInputDialog,
//             custInputopen: false,
//             custInputAdd:
//               !isEmpty(response.data.jcJson.custId) ||
//               !isEmpty(response.data.jcJson.custMob),
//             redeemRoyaltyPrice:
//               parseFloat(response.data.jcJson.royalityPoint) > 0.0,
//           });
//           setIsCustDataAvailable(isEmpty(response.data.jcJson.custId));
//           if (
//             response.data.jcJson.billStatus === BillStatus.PAID ||
//             response.data.jcJson.billStatus === BillStatus.PARTIALLYPAID ||
//             response.data.jcJson.billStatus ===
//               BillStatus.HOMEDELIVERYINITIATED ||
//             response.data.jcJson.billStatus ===
//               BillStatus.HOMEDELIVERYCASHPAY ||
//             response.data.jcJson.billStatus === BillStatus.HOMEDELIVERYPAY
//           ) {
//             setIsPaid(true);
//           }
//           setOnlinePayEnb(parseFloat(response.data.jcJson.onlinePay) > 0);
//           setCashPayEnb(response.data.jcJson.cashPayThrough === CASHPAY);
//         } else {
//           setSnpComponent({
//             ...snpComponent,
//             showDialog: true,
//             title: "",
//             iconReq: true,
//             isLoader: false,
//             negativeReq: true,
//             cancelExtra: true,
//             requestType: DashboardComponent.BILLDETAILS,
//             outSideClickDismiss: false,
//             subTitle:
//               "You Are not allowed to Change In Bills.Contact the Owner",
//             negativeAction: "Got It!",
//           });
//           setSnpLoader(false);
//         }
//       })
//       .catch((error) => {
//         setSnpLoader(false);
//         printDebugLog("errr ", error);
//         setSnpComponent({
//           ...snpComponent,
//           showDialog: true,
//           title: "",
//           iconReq: true,
//           isLoader: false,
//           negativeReq: true,
//           cancelExtra: true,
//           requestType: DashboardComponent.BILLDETAILS,
//           outSideClickDismiss: false,
//           subTitle:
//             "You Are not allowed to Change In this Bills.Contact the Owner",
//           negativeAction: "Got It!",
//         });
//         //window.location.href = "#/error";
//       });
//   } else {
//     //printLog("Empty Bill No");
//   }
// };

export const billDetailsReducer = billDetails.reducer;
export const {
  setBillDetails,
  addItemToBill,
  updateBillItem,
  updateBillDetails,
  removeItemFromBill,
  updateBillPaymentDetails,
  updatebillHotelDetails,
  updateBillRiderDetails,
  addCachedBillProductDetails,
  updateBillCustomerDetails,
  updateBillPartialPaymentDetails,
  clearBill,
  addDeletedBillItem,
} = billDetails.actions;

// const getBillItems = async (billNo) => {
//   try {
//     setColumnLoader(true);
//     const fetchBillUrl = `${storeApiUrl.BACKEND_BASE_URL}billing/get-bill-items?token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}&billNo=${billNo}`;
//     const response = await snpAxios.get(fetchBillUrl);
//     printDebugLog("getBillItems", response.data);
//     if (response.data.status === SUCCESS) {
//       const payLoad = response.data.jcJson;
//       setColumnList(payLoad.columnList);
//       setDelItems(payLoad.delItems);
//     }
//     setColumnLoader(false);
//   } catch (e) {
//     console.error("getBillItems", e);
//     setColumnLoader(false);
//   }
// };
// const getBillDetails = async (billNo) => {
//   try {
//     const fetchBillUrl = `${storeApiUrl.BACKEND_BASE_URL}billing/get-bill-details?token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}&billNo=${billNo}`;
//     const response = await snpAxios.get(fetchBillUrl);
//     printDebugLog("getBillDetails", response.data);
//     if (response.data.status === SUCCESS) {
//       const payLoad = response.data.jcJson;
//       if (!isEmpty(payLoad.billAddBy)) {
//         setBillAddBy(payLoad.billAddBy);
//       }
//       if (!isEmpty(payLoad.tableOwner)) {
//         setTableOwner(payLoad.tableOwner);
//       }
//       setKot(Number(payLoad.kot));
//       setBillNo(payLoad.billNo);
//       setBilledFrom(Number(payLoad.billedFrom));
//       setGenateOtp(payLoad.generateOtp);
//       setCreatedDate(payLoad.createdAt);
//       setSettleDown(payLoad.settleDown);
//       setCreatedDate(payLoad.createdAt);
//       setCustAvailable(payLoad.custAvailable);
//       const kBillStatus = Number(payLoad.billStatus);
//       if (
//         kBillStatus === BillStatus.PAID ||
//         kBillStatus === BillStatus.PARTIALLYPAID ||
//         kBillStatus === BillStatus.HOMEDELIVERYINITIATED ||
//         kBillStatus === BillStatus.HOMEDELIVERYCASHPAY ||
//         kBillStatus === BillStatus.HOMEDELIVERYPAY
//       ) {
//         setIsPaid(true);
//       }
//       setBillStatus(kBillStatus);
//       setTokenNo(Number(payLoad.tokenNo));
//       if (payLoad.custAvailable) {
//         setCustomerData((prev) => ({
//           ...prev,
//           ...payLoad.customerData,
//         }));
//       }
//       setBillUtils((prev) => ({
//         ...prev,
//         ...payLoad.billUtils,
//       }));
//       setExternalBillDetails((prev) => ({
//         ...prev,
//         ...payLoad.externalMap,
//       }));
//       setTripDetails((prev) => ({
//         ...prev,
//         ...payLoad.tripMap,
//         pTripStatus: payLoad.tripMap.tripStatus,
//       }));
//       setReferenceBill((prev) => ({
//         ...prev,
//         ...payLoad.referencesMap,
//       }));
//     }
//   } catch (e) {
//     console.error("getBillDetails", e);
//   }
// };

// const getBillPayDetails = async (billNo) => {
//   try {
//     const fetchBillUrl = `${storeApiUrl.BACKEND_BASE_URL}billing/get-bill-pay-details?token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}&billNo=${billNo}`;
//     const response = await snpAxios.get(fetchBillUrl);
//     printDebugLog("getBillPayDetails", response.data);
//     if (response.data.status === SUCCESS) {
//       const payLoad = response.data.jcJson;
//       setPaymentDetails((prev) => ({
//         ...prev,
//         ...payLoad,
//       }));
//     }
//   } catch (e) {
//     console.error("getBillPayDetails", e);
//   }
// };

const handlePending = (state, key) => {
  state[key].loading = true;
  state[key].error = null;
};

const handleRejected = (state, action, key) => {
  state[key].loading = false;
  state[key].error = {
    status: action.payload?.status ?? "UNKNOWN",
    message: action.payload?.message ?? "Something went wrong",
  };
  const { billType, tableId, tableNo, tableName } = state.billDetails;
  const { isGstAllowed } = state.billPaymentDetails;
  state.billDetails = {
    ...INITIAL_BILL_DETAILS_STATE,
    billNo: "",
    billType,
    tableId,
    tableNo,
    tableName,
  };
  state.billPaymentDetails = {
    ...INITIAL_BILL_PAYMENT_DETAILS_STATE,
    isGstAllowed,
  };
  state.billHotelDetails = INITIAL_BILL_HOTEL_DETAILS_STATE;
  state.billRiderDetails = INITIAL_RIDER_DETAILS_STATE;
  state.billCustomerDetails = INITIAL_BILL_CUSTOMER_DETAILS;
  state.billItems = [];
  state.billCachedProductDetails = [];
};

const handleBillDetailsFulfilled = (state, action) => {
  state.billDetailsFetch = resetFetchState(state.billDetailsFetch);
  state.billDetails = {
    ...state.billDetails,
    ...populateBillDetails(action.payload),
  };
  state.billCustomerDetails = {
    ...state.billCustomerDetails,
    ...populateCustomerDetails(action.payload),
  };
  state.billRiderDetails = {
    ...state.billRiderDetails,
    ...populateRiderDetails(action.payload),
  };
  state.billHotelDetails = {
    ...state.billHotelDetails,
    ...populateRoomDetails(action.payload),
  };
};

const handleBillItemsFulfilled = (state, action) => {
  state.billItemsFetch = resetFetchState(state.billItemsFetch);
  state.billItems = populateBillItem(action.payload.columnList);
  state.billDeletedItems = populateBillItem(action.payload.delItems);
};

const handleBillPaymentFulfilled = (state, action) => {
  state.billPaymentFetch = resetFetchState(state.billPaymentFetch);
  state.billPaymentDetails = populatePaymentsDetails(action.payload);
};

const handleBillPartialPaymentFulfilled = (state, action) => {
  state.billPartialPaymentFetch = resetFetchState(
    state.billPartialPaymentFetch
  );
  state.billPartialPaymentDetails = populatePartialBillPaymentDetails(
    action.payload
  );
};

const resetFetchState = (fetchState) => ({
  ...fetchState, ...INITIAL_LOADING_AND_ERROR_STATE
});
